import {useContext, useEffect} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import Helmet from '@s-ui/react-head'
import {useMount} from '@s-ui/react-hooks'
import {useRouter} from '@s-ui/react-router'
import Layout from '@adv-mt/mt-layout-basic'
import MotorLoginContainer from '@adv-mt/mt-login-container'
import {rejectAll, resetAndCleanCmp} from '@adv-mt/mt-shared-cmp'
import TrackingAuthentication from '@adv-mt/mt-tracking-authentication'
import MotorTrackingCriteo from '@adv-mt/mt-tracking-criteo'

import LinkFactory from '../../components/LinkFactory/index.js'
import {getInitialProps} from './getInitialProps.js'
import {closeOpenerIfCrossOrigin} from './helpers.js'

const BASE_CLASS = 'mt-Login'

const TCF_VERSION = 2

const Login = ({helmet, targetPage}) => {
  const {domain} = useContext(Context)
  const {HIT_ORIGINS} = domain.get('config').get('tracking')
  const {
    location: {search}
  } = useRouter()

  const isCmpAuth = Boolean(search?.match(/cmpAuth=true/))

  const _goTo = url => (window.location = url)

  useEffect(() => {
    let listenerId = null

    if (isCmpAuth) {
      window?.__tcfapi('addEventListener', TCF_VERSION, (tcData, success) => {
        listenerId = tcData.listenerId

        setTimeout(() => {
          resetAndCleanCmp()
        })
      })
    }

    return () => {
      window?.__tcfapi('removeEventListener', TCF_VERSION, () => null, listenerId)
    }
  }, [isCmpAuth]) // eslint-disable-line

  useMount(() => {
    const {unsubscribe} = domain.get('login_authentication_use_case').subscribe(({result: {url}}) => {
      isCmpAuth && rejectAll()
      _goTo(url)
    })

    return () => {
      unsubscribe()
    }
  })

  useMount(() => {
    closeOpenerIfCrossOrigin()
  })

  const topbarProps = {
    withLoginButton: false
  }

  return (
    <Layout.Basic linkFactory={LinkFactory} isMarginless isPaddingless topbarProps={topbarProps}>
      <Helmet {...helmet} />
      <div className={BASE_CLASS}>
        <MotorLoginContainer targetPage={targetPage} />
      </div>
      <TrackingAuthentication trackingOrigin={HIT_ORIGINS.LOGIN_PAGE} />
      <MotorTrackingCriteo />
    </Layout.Basic>
  )
}

Login.displayName = 'Login'

Login.propTypes = {
  helmet: PropTypes.object,
  isCmpAuth: PropTypes.bool,
  targetPage: PropTypes.string
}

Login.getInitialProps = getInitialProps

export default Login
